import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Cash from 'shared/img/education-onboarding/cash.svg';
import styles from '../Resume/styles.module.scss';

const ViewScholarships = () => (
  <BaseStep
    stepHeader={
      <>
        <Cash className={styles.icon} width={143} />
        How you cash in
      </>
    }
    subHeader={
      <>
        The money you earn comes from your college. After you reach the minimum earning amount, your
        earnings will be applied toward the next school year’s tuition and fees.
      </>
    }
  />
);

export default ViewScholarships;
